import apiClient, { API_ENDPOINTS, appendPath, dispatchAndResolve, rejectWithError } from "api";
import * as types from "./types.jsx";

const { discount } = API_ENDPOINTS;

const rejectDiscountError = (error, label) => rejectWithError(error, label);

export const createDiscount = (discountPayload) => async (dispatch) => {
    try {
        const data = await apiClient.post(discount.create, discountPayload);
        return dispatchAndResolve(dispatch, types.CREATE_DISCOUNT, data);
    } catch (error) {
        return rejectDiscountError(error, "Error creating discount");
    }
};

export const updateDiscount = (discountPayload) => async (dispatch) => {
    try {
        const data = await apiClient.post(discount.update, discountPayload);
        return dispatchAndResolve(dispatch, types.UPDATE_DISCOUNT, data);
    } catch (error) {
        return rejectDiscountError(error, "Error updating discount");
    }
};

export const getDiscount = (id) => async (dispatch) => {
    try {
        const data = await apiClient.get(appendPath(discount.getById, id));
        return dispatchAndResolve(dispatch, types.GET_DISCOUNT, data);
    } catch (error) {
        dispatch({ type: types.GET_DISCOUNT_FAILURE, payload: error?.message || error });
        return rejectDiscountError(error, "Error getting discount");
    }
};

export const getDiscountWithCompany = (id, companyId) => async (dispatch) => {
    try {
        const data = await apiClient.get(appendPath(discount.getByIdWithCompany, companyId, id));
        return dispatchAndResolve(dispatch, types.GET_DISCOUNT_WITH_COMPANY, data);
    } catch (error) {
        dispatch({ type: types.GET_DISCOUNT_WITH_COMPANY_FAILURE, payload: error?.message || error });
        return rejectDiscountError(error, "Error getting discount with company");
    }
};

export const findDiscountsByCriteria = (criteria) => async (dispatch) => {
    try {
        const data = await apiClient.post(discount.findByCriteria, criteria);
        return dispatchAndResolve(dispatch, types.FIND_DISCOUNTS, data);
    } catch (error) {
        return rejectDiscountError(error, "Error finding discounts");
    }
};

export const findDiscountsByIds = (ids) => async (dispatch) => {
    try {
        const data = await apiClient.post(discount.findByIds, ids);
        return dispatchAndResolve(dispatch, types.FIND_DISCOUNTS_BY_IDS, data);
    } catch (error) {
        return rejectDiscountError(error, "Error finding discounts by ids");
    }
};

export const deleteDiscount = (id) => async (dispatch) => {
    try {
        const data = await apiClient.delete(appendPath(discount.delete, id));
        return dispatchAndResolve(dispatch, types.DELETE_DISCOUNT, data);
    } catch (error) {
        return rejectDiscountError(error, "Error deleting discount");
    }
};

export const removeDiscount = (id) => async (dispatch) => {
    try {
        const data = await apiClient.put(appendPath(discount.remove, id));
        return dispatchAndResolve(dispatch, types.REMOVE_DISCOUNT, data);
    } catch (error) {
        return rejectDiscountError(error, "Error removing discount");
    }
};

export const findEligibleDiscounts = (criteria) => async (dispatch) => {
    try {
        const data = await apiClient.post(discount.eligibleDiscounts, criteria);
        return dispatchAndResolve(dispatch, types.FIND_ELIGIBLE_DISCOUNTS, data);
    } catch (error) {
        return rejectDiscountError(error, "Error finding eligible discounts");
    }
};
